<template>
    <div v-if="detalhesArr.length != 0">
        <div class="text-center">
            <h4><b>Detalhes da Licença</b></h4>
        </div>
        <table>
            <tr>
                <th>Banco de Dados</th>
                <th>Usuários Ativos</th>
                <th>Terminais Ativos</th>
                <th>Terminais Operando</th>
            </tr>
            <tr v-for="(a, i) in detalhesArr" :key="i">
                <td>{{ a.TERNEOCAMINHOBD }}</td>
                <td>{{ a.USUARIOS }}</td>
                <td>{{ a.ATIVOS }}</td>
                <td>{{ a.ACESSADO }}</td>
            </tr>
        </table>
    </div>
</template>
<script>

import * as Clientes from "../../providers/clientes.service";

export default {
    props: ["cliente"],
    data() {
        return {
            detalhesArr: []
        };
    },
    created() {
        this.getLiberados(this.cliente);
    },
    methods: {
        getLiberados(cliente) {
            debugger
            var self = this;
            Clientes.getDetalhesLicensa({ CLICODIGO: cliente.CLICODIGO }).then(
                r => {
                    self.detalhesArr = r.Rows;
                }
            );
        }
    }
};
</script>
<style>
table {
    width: 100%;
}

td,
th {
    border: 1px solid rgb(233, 233, 233);
    text-align: left;
    padding: 8px;
}

tr:nth-child(even) {
    background-color: #CFDFE5;
}
</style>